import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const Title = styled.h3`
  ${typographyV2.titleLg};
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  opacity: 15%;
`;

export const Image = styled.img`
  width: 400px;
  height: auto;
`;

export const LoadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
